module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('blockquote', {
    staticClass: "epigraph",
    attrs: {
      "epub:type": "epigraph",
      "role": "doc-epigraph"
    }
  }, [_c('p', {
    staticClass: "epi"
  }, [_c('span', {
    attrs: {
      "aria-label": "page viii",
      "epub:type": "pagebreak",
      "id": "page_viii",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "page ix",
      "epub:type": "pagebreak",
      "id": "page_ix",
      "role": "doc-pagebreak"
    }
  }, [_c('i', [_vm._v("And I will show that nothing can happen more beautiful than death.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "epir"
  }, [_vm._v("—Walt Whitman")]), _vm._v(" "), _c('p', {
    staticClass: "epir1"
  }, [_c('i', [_vm._v(" Leaves of Grass")]), _vm._v(", “Proto-Leaf” (1860)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd7f70d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781982140632/xhtml/epigraph.vue
// module id = 75
// module chunks = 0